import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

// Toast
import {
  selectToastVisibilityStatus,
  selectToastType,
  selectToastTitle,
  selectToastMessage,
  selectToastDuration,
} from "../../../redux/features/applicationState/applicationStateSlice";
import Toast from "../../Toast/Toast";
// import WidthWarning from "../../WidthWarning/WidthWarning";

const GeneralLayout = () => {
  // Toast
  const toastVisibilityStatus = useSelector(selectToastVisibilityStatus);
  const toastType = useSelector(selectToastType);
  const toastTitle = useSelector(selectToastTitle);
  const toastMessage = useSelector(selectToastMessage);
  const toastDuration = useSelector(selectToastDuration);
  return (
    <main className="App">
      {/* <WidthWarning /> */}
      {/* Toast displays statuses based on user interaction across application */}
      {toastVisibilityStatus && (
        <Toast
          toastType={toastType}
          title={toastTitle}
          message={toastMessage}
          toastDuration={toastDuration}
        />
      )}
      {/* Outlet is the children of Layout. Anything nested inside the Layout. */}
      <Outlet />
    </main>
  );
};

export default GeneralLayout;
